import { GATrackingEvent } from '../ga-tracking-event.model';
import { GATrackingEventPayload } from '../ga-tracking-event-payload.model';
import { GaTrackingEventCategory } from '../../constants';

export class GATrackingSearchBannerEvent implements GATrackingEvent {
  constructor(private payload: any) {}

  getEventType(): any {
    return this.payload.action;
  }

  getPayload(): GATrackingEventPayload {
    return {
      event: this.payload.action,
      label: this.payload.label,
      gtmCustom: {
        action: this.payload.action,
        category: GaTrackingEventCategory.Interaction
      }
    };
  }
}
